import { React } from "react";
import DashboardLink from "./DashboardLink";
import Links from "../../Links";
import "./DashboardNav.css";
import ExitIcon from "../../Components/DashboardNav/Icons/ExitIcon";
import { NavLink } from "react-router-dom";

const DashboardNav = (props) => {
  return (
    <nav className={props.menuIsOpen ? "side-bar side-bar-open" : "side-bar"}>
      <ul>
        {Links.map((link) => (
          <li key={link.linkName}>
            <DashboardLink
              to={link.to}
              linkName={link.linkName}
              icon={link.icon}
              handleSideBarLinkClick={props.handleSideBarLinkClick}
            />
          </li>
        ))}
        <li>
          <NavLink
            to="/"
            exact={true}
            className="dashboard-link sign-out-link"
            onClick={props.handleSignOut}
          >
            <ExitIcon />
            SignOut
          </NavLink>
        </li>
      </ul>
    </nav>
  );
};

export default DashboardNav;
